import { createGlobalStyle } from 'styled-components';

const TestingStyles = createGlobalStyle`
  .top-navigation,
  .ts__exit-btn {
    display: none !important;
  }

  .ts__wrapper {
    padding: 0 !important;
    min-height: initial !important;
    display: initial !important;
  }

`

export default TestingStyles